import React from 'react';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';
import { Product } from '../../../types/Product';
import { InsightCard } from './InsightCard';
import { calculateInsights } from '../../../utils/statistics/insights';

interface StatisticsInsightsProps {
  products: Product[];
}

export const StatisticsInsights: React.FC<StatisticsInsightsProps> = ({ products }) => {
  const insights = calculateInsights(products);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Brain className="text-orange-500" size={20} />
        <h3 className="text-lg font-semibold">Insights y Recomendaciones</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {insights.map((insight, index) => (
          <InsightCard
            key={index}
            {...insight}
            delay={index * 0.1}
          />
        ))}
      </div>
    </div>
  );
};